/* eslint-disable max-len */
/* eslint-disable no-extra-parens */
/* eslint-disable max-lines */
/* eslint-disable complexity */
/* eslint-disable sort-keys */
import {
    css, keyframes,
} from '@stitches/react'

import {NinchatEnvironmentConfig} from 'embed/types'
import {ResponsiveBreakpoints} from 'embed/types/responsive'
import {ThemeManager} from '../helpers/themeManager'

const EMBED_HEADER_HEIGHT_DEFAULT = 60
const EMBED_WIDTH_DEFAULT = 400
const EMBED_WIDTH_FULL_DEFAULT = 460
const EMBED_HEIGHT_DEFAULT = 700
const BALL_HEIGHT_DEFAULT = 76
const BALL_WIDTH_DEFAULT = 76

const TRANSITION_DURATION = '.3'
const ANIMATION_DURATION = '.3'
const BALL_TRANSITION_DURATION = '.3'

const animations = () => {
    const rotate = keyframes({
        '0%': {transform: 'rotate(0deg)'},
        '100%': {transform: 'rotate(360deg)'},
    })

    const slideRight = (height: string, width: string, right: string | number) => keyframes({
        '0%': {
            right: `-${width}`,
            transform: 'translate(0, -50%)',
            height,
        },
        '100%': {
            right,
            transform: 'translate(0, -50%)',
            height,
        },
    })

    const slideRightBack = (height: string, width: string, right: string) => keyframes({
        '0%': {
            right,
            transform: 'translate(0, -50%)',
            width,
            height,
        },
        '100%': {
            right: `-${width}`,
            transform: 'translate(0, -50%)',
            height,
            width,
        },
    })

    const slideLeft = (height: string, width: string, left: string | number) => keyframes({
        '0%': {
            left: `-${width}`,
            transform: 'translate(0, -50%)',
            height,
            width,
        },
        '100%': {
            left,
            transform: 'translate(0, -50%)',
            height,
            width,
        },
    })

    const slideLeftBack = (height: string, width: string, left: string) => keyframes({
        '0%': {
            left,
            transform: 'translate(0, -50%)',
            height,
            width,
        },
        '100%': {
            left: `-${width}`,
            transform: 'translate(0, -50%)',
            height,
            width,
        },
    })

    return {
        slideRight,
        slideRightBack,
        slideLeft,
        slideLeftBack,
        rotate,
    }
}

export const iframe = () => css({
    border: 0,
    height: '100%',
    width: '100%',
    display: 'block',
})()

export const floatingContainerWrapper = (defaultConfig: NinchatEnvironmentConfig, tmDefault: ThemeManager, breakpoints: ResponsiveBreakpoints) => {
    const renderStyles = (_config: NinchatEnvironmentConfig, tm: ThemeManager) => ({
        fontFamily: '"Open Sans Ninchat Embed", sans-serif',
        position: 'fixed',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        pointerEvents: 'none',
        zIndex: `${tm.getTheme().zIndices.floatingEmbed.value}`,
        button: {
            transition: 'all 0.15s',
            fontFamily: '"Open Sans Ninchat Embed", sans-serif',
        },
    })

    const mediaQueriesOverrides = breakpoints.reduce((acc: any, breakpoint: ResponsiveBreakpoints[0]) => {
        const {
            mediaQuery, tm: tmNew, config: newConfig,
        } = breakpoint

        acc[`@media ${mediaQuery}`] = renderStyles(newConfig, tmNew)
        return acc
    }, {})

    return css({
        ...renderStyles(defaultConfig, tmDefault),
        ...mediaQueriesOverrides,
    })()
}

const floatingContainerMinimized = (floatingOptions: NinchatEnvironmentConfig['floatingOptions']) => {
    const isDockRight = floatingOptions?.dock?.right && !floatingOptions?.dock?.bottom
    const isDockLeft = floatingOptions?.dock?.left && !floatingOptions?.dock?.bottom
    const isBall = floatingOptions?.ball

    const embedHeight = floatingOptions?.height || `${EMBED_HEIGHT_DEFAULT}px`
    const embedWidth = floatingOptions?.width?.minimized || `${EMBED_WIDTH_DEFAULT}px`
    const embedWidthDefault = floatingOptions?.width?.open || `${EMBED_WIDTH_DEFAULT}px`
    const headerHeight = floatingOptions?.headerOptions?.height || EMBED_HEADER_HEIGHT_DEFAULT

    const {
        slideRightBack, slideLeftBack,
    } = animations()

    return {
        '&.ninchat-embed-minimized': {
            'height': `${headerHeight}px`,
            'width': embedWidth,
            ...isDockRight
                ? {
                    '&.state-changed-by-user': {animation: `${slideRightBack(embedHeight, embedWidthDefault, `calc(${floatingOptions?.offset?.x || 0}px + ${headerHeight / 2}px)`)} ${ANIMATION_DURATION}s linear`},
                    'transform': 'translate(50%, -50%) rotate(-90deg)',
                    'top': `calc(50% + ${floatingOptions?.offset?.y || 0}px)`,
                    'right': `calc(${floatingOptions?.offset?.x || 0}px + ${headerHeight / 2}px)`,
                }
                : {},
            ...isDockLeft
                ? {
                    '&.state-changed-by-user': {animation: `${slideLeftBack(embedHeight, embedWidthDefault, `calc(${floatingOptions?.offset?.x || 0}px + ${headerHeight / 2}px)`)} ${ANIMATION_DURATION}s linear`},
                    'transform': 'translate(-50%, -50%) rotate(90deg)',
                    'top': `calc(50% + ${floatingOptions?.offset?.y || 0}px)`,
                    'left': `calc(${floatingOptions?.offset?.x || 0}px + ${headerHeight / 2}px)`,
                }
                : {},
            ...isBall
                ? {
                    'bottom': `-${embedHeight}`,
                    'height': embedHeight,
                    '&.minimize-transition-end': {visibility: 'hidden'},
                }
                : {},
            '.ninchat-embed-header': {borderBottom: 'none'},
            '.ninchat-embed-buttons.left': {display: 'none'},
            '.ninchat-embed-minimize-button': {display: 'none'},
            '.ninchat-embed-promobubble-wrapper': {visibility: 'visible'},
            '.ninchat-embed-content': {visibility: 'hidden'},
        },
    }
}

const floatingContainerFull = (floatingOptions: NinchatEnvironmentConfig['floatingOptions']) => {
    const embedWidth = floatingOptions?.width?.full || `${EMBED_WIDTH_FULL_DEFAULT}px`

    return {
        '&.ninchat-embed-full': {
            height: `calc(100vh - ${(floatingOptions?.offset?.y || 0) * 2}px)`,
            width: embedWidth,
        },
    }
}

export const floatingContainer = (defaultConfig: NinchatEnvironmentConfig, tmDefault: ThemeManager, breakpoints: ResponsiveBreakpoints) => {
    const renderStyles = (config: NinchatEnvironmentConfig, tm: ThemeManager) => {
        const floatingOptions = config?.floatingOptions
        const isDockBottom = floatingOptions?.dock?.bottom || Object.keys(floatingOptions?.dock || {}).length === 0
        const isDockRight = floatingOptions?.dock?.right && !floatingOptions?.dock?.bottom
        const isDockCenter = floatingOptions?.dock?.center
        const isDockLeft = floatingOptions?.dock?.left && !floatingOptions?.dock?.bottom
        const isBall = floatingOptions?.ball
        const embedHeight = floatingOptions?.height || `${EMBED_HEIGHT_DEFAULT}px`
        const embedWidth = floatingOptions?.width?.open || `${EMBED_WIDTH_DEFAULT}px`

        const {
            slideRight, slideLeft,
        } = animations()

        return {
            'bottom': isDockBottom ? floatingOptions?.offset?.y || 0 : 'auto',
            'left': floatingOptions?.dock?.left ? floatingOptions?.offset?.x || 0 : 'auto',
            'right': floatingOptions?.dock?.right ? floatingOptions?.offset?.x || 0 : 'auto',
            'height': embedHeight,
            'maxHeight': `calc(100vh - ${(floatingOptions?.offset?.y || 0) * 2}px)`,
            'position': 'absolute',
            'pointerEvents': 'all',
            'width': embedWidth,
            'zIndex': `${tm.getTheme().zIndices.floatingEmbed.value}`,
            'borderTopLeftRadius': `${tm.getTheme().radii.floatingEmbed.value}`,
            'borderTopRightRadius': `${tm.getTheme().radii.floatingEmbed.value}`,
            '&.transitions-enabled': {
                transition: `height ${TRANSITION_DURATION}s, width ${TRANSITION_DURATION}s`,
                ...isBall
                    ? {transition: `bottom ${BALL_TRANSITION_DURATION}s, width ${BALL_TRANSITION_DURATION}s, height ${BALL_TRANSITION_DURATION}s`}
                    : {},
            },
            '&.hide': {visibility: 'hidden'},
            ...!isDockLeft && !isDockRight
                ? {maxWidth: `calc(100vw - ${floatingOptions?.offset?.x}px)`}
                : {},
            ...isDockCenter
                ? {
                    left: '50%',
                    transform: 'translateX(-50%)',
                    ...floatingOptions?.dock?.bottom
                        ? {}
                        : {
                            top: '50%',
                            transform: 'translate(-50%, -50%)',
                        },
                }
                : {},
            ...isDockRight
                ? {
                    '&.state-changed-by-user:not(.ninchat-embed-minimized)': {animation: `${slideRight(embedHeight, embedWidth, floatingOptions?.dock?.right ? floatingOptions?.offset?.x || 0 : 'auto')} ${ANIMATION_DURATION}s linear`},
                    '&:not(.ninchat-embed-minimized) .ninchat-embed-inner': {borderRadius: `${tm.getTheme().radii.floatingEmbed.value}`},
                    'transform': 'translateY(-50%)',
                    'top': `calc(50% + ${floatingOptions?.offset?.y || 0}px)`,
                }
                : {},
            ...isDockLeft
                ? {
                    '&.state-changed-by-user:not(.ninchat-embed-minimized)': {animation: `${slideLeft(embedHeight, embedWidth, floatingOptions?.dock?.left ? floatingOptions?.offset?.x || 0 : 'auto')} ${ANIMATION_DURATION}s linear`},
                    '&:not(.ninchat-embed-minimized) .ninchat-embed-inner': {borderRadius: `${tm.getTheme().radii.floatingEmbed.value}`},
                    'transform': 'translateY(-50%)',
                    'top': `calc(50% + ${floatingOptions?.offset?.y || 0}px)`,
                }
                : {},
            ...floatingContainerMinimized(floatingOptions),
            ...floatingContainerFull(floatingOptions),
        }
    }

    const mediaQueriesOverrides = breakpoints.reduce((acc: any, breakpoint: ResponsiveBreakpoints[0]) => {
        const {
            mediaQuery, tm: tmNew, config: newConfig,
        } = breakpoint

        acc[`@media ${mediaQuery}`] = renderStyles(newConfig, tmNew)
        return acc
    }, {})

    return css({
        ...renderStyles(defaultConfig, tmDefault),
        ...mediaQueriesOverrides,
    })()
}


export const floatingContainerInner = (defaultConfig: NinchatEnvironmentConfig, tmDefault: ThemeManager, breakpoints: ResponsiveBreakpoints) => {
    const renderStyles = (config: NinchatEnvironmentConfig, tm: ThemeManager) => {
        const {floatingOptions} = config
        const isDockBottom = floatingOptions?.dock?.bottom || Object.keys(floatingOptions?.dock || {}).length === 0
        const isDockingLeftOrRightWithXOffset = floatingOptions?.offset?.x && floatingOptions?.offset?.x > 0 && (floatingOptions?.dock?.left || floatingOptions?.dock?.right) && !isDockBottom
        const isDockBottomWithYOffset = floatingOptions?.offset?.y && floatingOptions?.offset?.y > 0 && isDockBottom

        return {
            background: `${tm.getTheme().colors.floatingEmbed.value}`,
            boxShadow: `${tm.getTheme().shadows.floatingEmbed.value}`,
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            overflow: 'hidden',
            borderTopLeftRadius: `${tm.getTheme().radii.floatingEmbed.value}`,
            borderTopRightRadius: `${tm.getTheme().radii.floatingEmbed.value}`,
            ...(isDockBottomWithYOffset || isDockingLeftOrRightWithXOffset)
                ? {borderRadius: `${tm.getTheme().radii.floatingEmbed.value}`}
                : {},
        }
    }

    const mediaQueriesOverrides = breakpoints.reduce((acc: any, breakpoint: ResponsiveBreakpoints[0]) => {
        const {
            mediaQuery, tm: tmNew, config: newConfig,
        } = breakpoint

        acc[`@media ${mediaQuery}`] = renderStyles(newConfig, tmNew)
        return acc
    }, {})

    return css({
        ...renderStyles(defaultConfig, tmDefault),
        ...mediaQueriesOverrides,
    })()
}

export const floatingContainerHeader = (defaultConfig: NinchatEnvironmentConfig, tmDefault: ThemeManager, breakpoints: ResponsiveBreakpoints) => {
    const renderStyles = (config: NinchatEnvironmentConfig, tm: ThemeManager) => {
        const {floatingOptions} = config
        const headerHeight = floatingOptions?.headerOptions?.height || EMBED_HEADER_HEIGHT_DEFAULT

        const {rotate} = animations()

        return {
            'alignItems': 'center',
            'backgroundColor': `${tm.getTheme().colors.floatingEmbedHeader.value}`,
            'borderColor': `${tm.getTheme().colors.floatingEmbedHeaderBorder.value}`,
            'borderBottomWidth': `${tm.getTheme().borderWidths.floatingEmbedHeaderBorder.value}`,
            'borderBottomStyle': `${tm.getTheme().borderStyles.floatingEmbedHeaderBorder.value}`,
            'boxSizing': 'border-box',
            'display': 'flex',
            'flexShrink': 0,
            'padding': `${tm.getTheme().space.floatingEmbedHeader.value}`,
            'position': 'relative',
            'height': `${headerHeight}px`,
            '.ninchat-embed-shrink-button': {display: 'none'},
            '.ninchat-embed-buttons': {
                'alignItems': 'center',
                'display': 'flex',
                'gap': '5px',
                'justifyContent': 'center',
                '> button': {
                    'alignItems': 'center',
                    'boxSizing': 'border-box',
                    'display': 'flex',
                    'cursor': 'pointer',
                    'justifyContent': 'center',
                    'height': '40px',
                    'minHeight': '40px',
                    'minWidth': '40px',
                    'background': 'none',
                    'border': 'none',
                    '&.hide': {display: 'none'},
                    '> span.text:not(:empty):not(:only-child)': {marginLeft: '5px'},
                    '&:not(.ninchat-embed-header-title-button)': {
                        'borderRadius': `${tm.getTheme().radii.floatingEmbedHeaderButton.value}`,
                        'padding': `${tm.getTheme().space.floatingEmbedHeaderButton.value}`,
                        'backgroundColor': `${tm.getTheme().colors.floatingEmbedHeaderButtonBackground.value}`,
                        'borderColor': `${tm.getTheme().colors.floatingEmbedHeaderButtonBorder.value}`,
                        'borderWidth': `${tm.getTheme().borderWidths.floatingEmbedHeaderButton.value}`,
                        'borderStyle': `${tm.getTheme().borderStyles.floatingEmbedHeaderButton.value}`,
                        'color': `${tm.getTheme().colors.floatingEmbedHeaderButton.value}`,
                        'fontFamily': `${tm.getTheme().fonts.floatingEmbedHeaderButton.value}`,
                        'fontSize': `${tm.getTheme().fontSizes.floatingEmbedHeaderButton.value}`,
                        'fontWeight': `${tm.getTheme().fontWeights.floatingEmbedHeaderButton.value}`,
                        '&:hover': {
                            'backgroundColor': `${tm.getTheme().colors.floatingEmbedHeaderButtonHoverBackground.value}`,
                            'color': `${tm.getTheme().colors.floatingEmbedHeaderButtonHover.value}`,
                            '.ninchat-embed-header-button-image': {svg: {color: `${tm.getTheme().colors.floatingEmbedHeaderButtonIconHover.value}`}},
                        },
                        '&:hover&:focus': {backgroundColor: `${tm.getTheme().colors.floatingEmbedHeaderButtonFocusBackground.value}`},
                        '&:focus-visible': {outline: `2px solid ${tm.getTheme().colors.floatingEmbedHeaderButtonActiveOutline.value}`},
                        'svg': {color: `${tm.getTheme().colors.floatingEmbedHeaderButtonIcon.value}`},
                    },
                    '&.ninchat-embed-close-button': {
                        'borderRadius': `${tm.getTheme().radii.floatingEmbedHeaderCloseButton?.value}`,
                        'padding': `${tm.getTheme().space.floatingEmbedHeaderCloseButton?.value}`,
                        'borderWidth': `${tm.getTheme().borderWidths.floatingEmbedHeaderCloseButton?.value}`,
                        'borderStyle': `${tm.getTheme().borderStyles.floatingEmbedHeaderCloseButton?.value}`,

                        'backgroundColor': `${tm.getTheme().colors.floatingEmbedHeaderCloseButtonBackground?.value}`,
                        'borderColor': `${tm.getTheme().colors.floatingEmbedHeaderCloseButtonBorder?.value}`,
                        'color': `${tm.getTheme().colors.floatingEmbedHeaderCloseButton?.value}`,
                        '&:hover': {
                            'backgroundColor': `${tm.getTheme().colors.floatingEmbedHeaderCloseButtonHoverBackground?.value}`,
                            'color': `${tm.getTheme().colors.floatingEmbedHeaderCloseButtonHover?.value}`,
                            '.ninchat-embed-header-button-image': {svg: {color: `${tm.getTheme().colors.floatingEmbedHeaderCloseButtonIconHover?.value}`}},
                        },
                        '&:hover&:focus': {backgroundColor: `${tm.getTheme().colors.floatingEmbedHeaderCloseButtonFocusBackground?.value}`},
                        '&:focus-visible': {outline: `2px solid ${tm.getTheme().colors.floatingEmbedHeaderCloseButtonActiveOutline?.value}`},
                        'svg': {color: `${tm.getTheme().colors.floatingEmbedHeaderCloseButtonIcon?.value}`},

                    },
                },
                '&.right': {
                    '> button': {
                        '> span.text:not(:empty):not(:only-child)': {
                            marginLeft: '0',
                            marginRight: '5px',
                        },
                    },
                },
                '&.center': {
                    'minWidth': 0,
                    'width': '100%',
                    'padding': '0 5px',
                    '&.no-left-actions': {justifyContent: 'flex-start'},
                },
            },
            '&.hero-visible': {borderBottom: 'none'},
            '&&& .ninchat-embed-header-title-button': {
                'cursor': 'default',
                'padding': '5px 10px',
                'pointerEvents': 'none',
                'width': '100%',
                '&.no-left-actions': {justifyContent: 'flex-start'},
                '&.active-button': {
                    'borderRadius': `${tm.getTheme().radii.floatingEmbedHeaderTitleButton?.value || tm.getTheme().radii.floatingEmbedHeaderButton.value}`,
                    'cursor': 'pointer',
                    'height': 'auto',
                    'pointerEvents': 'all',
                    'padding': `${tm.getTheme().space.floatingEmbedHeaderTitleButton?.value}`,
                    'backgroundColor': `${tm.getTheme().colors.floatingEmbedHeaderTitleButtonBackground?.value || tm.getTheme().colors.floatingEmbedHeaderButtonBackground.value}`,
                    'borderColor': `${tm.getTheme().colors.floatingEmbedHeaderTitleButtonBorder?.value || tm.getTheme().colors.floatingEmbedHeaderButtonBorder.value}`,
                    'borderWidth': `${tm.getTheme().borderWidths.floatingEmbedHeaderTitleButton?.value || tm.getTheme().borderWidths.floatingEmbedHeaderButton.value}`,
                    'borderStyle': `${tm.getTheme().borderStyles.floatingEmbedHeaderTitleButton?.value || tm.getTheme().borderStyles.floatingEmbedHeaderButton.value}`,
                    '.ninchat-embed-header-title': {color: `${tm.getTheme().colors.floatingEmbedHeaderTitleButtonTitle?.value || tm.getTheme().colors.floatingEmbedHeaderTitle.value}`},
                    '.ninchat-embed-header-subtitle': {color: `${tm.getTheme().colors.floatingEmbedHeaderTitleButtonSubtitle?.value || tm.getTheme().colors.floatingEmbedHeaderSubtitle.value}`},
                    '.ninchat-embed-header-image-wrapper': {color: `${tm.getTheme().colors.floatingEmbedHeaderTitleButtonIcon?.value || tm.getTheme().colors.floatingEmbedHeaderIcon.value}`},
                    '&:hover': {
                        'backgroundColor': `${tm.getTheme().colors.floatingEmbedHeaderTitleButtonHoverBackground?.value || tm.getTheme().colors.floatingEmbedHeaderButtonHoverBackground.value}`,
                        '.ninchat-embed-header-title': {color: `${tm.getTheme().colors.floatingEmbedHeaderTitleButtonTitleHover?.value}`},
                        '.ninchat-embed-header-subtitle': {color: `${tm.getTheme().colors.floatingEmbedHeaderTitleButtonSubtitleHover?.value}`},
                        '.ninchat-embed-header-image-wrapper': {color: `${tm.getTheme().colors.floatingEmbedHeaderTitleButtonIconHover?.value || tm.getTheme().colors.floatingEmbedHeaderButtonIconHover.value}`},
                    },
                    '&:hover&:focus': {backgroundColor: `${tm.getTheme().colors.floatingEmbedHeaderTitleButtonFocusBackground?.value || tm.getTheme().colors.floatingEmbedHeaderButtonFocusBackground.value}`},
                    '&:focus-visible': {outline: `2px solid ${tm.getTheme().colors.floatingEmbedHeaderTitleButtonActiveOutline?.value || tm.getTheme().colors.floatingEmbedHeaderButtonActiveOutline.value}`},
                },
            },
            '.ninchat-embed-header-content': {
                alignItems: 'center',
                boxSizing: 'border-box',
                display: 'flex',
                height: '100%',
                justifyContent: 'space-between',
                // padding: '10px',
                width: '100%',
                cursor: 'default',
                textDecoration: 'none',
            },
            '.ninchat-embed-header-title-wrapper': {
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                flex: 1,
                maxWidth: '100%',
                minWidth: 0,
            },
            '.ninchat-embed-header-title': {
                color: `${tm.getTheme().colors.floatingEmbedHeaderTitle.value}`,
                fontFamily: `${tm.getTheme().fonts.floatingEmbedHeaderTitle.value}`,
                fontSize: `${tm.getTheme().fontSizes.floatingEmbedHeaderTitle.value}`,
                fontWeight: `${tm.getTheme().fontWeights.floatingEmbedHeaderTitle.value}`,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                textAlign: 'left',
            },
            '.ninchat-embed-header-subtitle': {
                color: `${tm.getTheme().colors.floatingEmbedHeaderSubtitle.value}`,
                fontFamily: `${tm.getTheme().fonts.floatingEmbedHeaderSubtitle.value}`,
                fontSize: `${tm.getTheme().fontSizes.floatingEmbedHeaderSubtitle.value}`,
                fontWeight: `${tm.getTheme().fontWeights.floatingEmbedHeaderSubtitle.value}`,
                whiteSpace: 'nowrap',
                textAlign: 'left',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            },
            '.ninchat-embed-header-image-wrapper': {
                'color': `${tm.getTheme().colors.floatingEmbedHeaderIcon.value}`,
                '&:empty': {display: 'none'},
                'display': 'flex',
                'alignItems': 'center',
                'justifyContent': 'center',
                'marginRight': '10px',
                'lineHeight': 0,
                '> div:not(:first-child), > img:not(:first-child)': {marginLeft: '-10px'},
                '.ninchat-embed-state-icon-wrapper + .ninchat-embed-header-image, .ninchat-embed-state-icon-wrapper + .ninchat-embed-header-image-svg-wrapper': {marginLeft: '10px'},
            },
            '.ninchat-embed-state-icon-wrapper': {
                'width': '25px',
                'height': '25px',
                'fontSize': '16px',
                'fontWeight': 'bold',
                '> svg': {
                    width: '100%',
                    height: '100%',
                },
                '&.newMessage': {
                    width: `${tm.getTheme().sizes.floatingEmbedHeaderNewMessageIcon.value}`,
                    height: `${tm.getTheme().sizes.floatingEmbedHeaderNewMessageIcon.value}`,
                },
                '&.video': {
                    width: `${tm.getTheme().sizes.floatingEmbedHeaderVideoIcon.value}`,
                    height: `${tm.getTheme().sizes.floatingEmbedHeaderVideoIcon.value}`,
                },
                '&.spinner': {
                    'position': 'relative',
                    'width': `${tm.getTheme().sizes.floatingEmbedHeaderInQueueLoader.value}`,
                    'height': `${tm.getTheme().sizes.floatingEmbedHeaderInQueueLoader.value}`,
                    'fontSize': `${tm.getTheme().fontSizes.floatingEmbedHeaderInQueueLoader.value}`,
                    '> svg': {animation: `${rotate} 2s linear infinite`},
                    '> span': {
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                    },
                },
            },
            '.ninchat-embed-header-image': {
                maxHeight: '100%',
                height: floatingOptions?.headerOptions?.image?.height ? `${floatingOptions?.headerOptions?.image?.height}px` : 'auto',
                width: floatingOptions?.headerOptions?.image?.width ? `${floatingOptions?.headerOptions?.image?.width}px` : 'auto',
            },
            '.ninchat-embed-header-image-svg-wrapper': {
                maxHeight: '100%',
                height: floatingOptions?.headerOptions?.image?.height ? `${floatingOptions?.headerOptions?.image?.height}px` : 'auto',
                width: floatingOptions?.headerOptions?.image?.width ? `${floatingOptions?.headerOptions?.image?.width}px` : 'auto',
            },
            '.ninchat-embed-member-image': {
                borderRadius: '40%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: `${tm.getTheme().sizes.floatingEmbedHeaderAvatar.value}`,
                height: `${tm.getTheme().sizes.floatingEmbedHeaderAvatar.value}`,
                overflow: 'hidden',
            },
            '.ninchat-embed-member-icon': {
                backgroundColor: `${tm.getTheme().colors.floatingEmbedHeaderAvatarBackground.value}`,
                borderRadius: '40%',
                border: `2px solid ${tm.getTheme().colors.floatingEmbedHeaderAvatarBorder.value}`,
                color: `${tm.getTheme().colors.floatingEmbedHeaderAvatar.value}`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: `${tm.getTheme().fontSizes.floatingEmbedHeaderAvatar.value}`,
                width: `${tm.getTheme().sizes.floatingEmbedHeaderAvatar.value}`,
                height: `${tm.getTheme().sizes.floatingEmbedHeaderAvatar.value}`,
            },
            '.ninchat-embed-header-button-image': {
                lineHeight: 0,
                svg: {color: `${tm.getTheme().colors.floatingEmbedHeaderButtonIcon.value}`},
            },
            '.ninchat-embed-header-button-image-svg-wrapper': {
                svg: {
                    width: '100%',
                    height: '100%',
                },
            },
            '.ninchat-embed-dropdown': {
                'backgroundColor': `${tm.getTheme().colors.dropdownBackground.value}`,
                'border': `1px solid ${tm.getTheme().colors.dropdownBorder.value}`,
                'borderRadius': '6px',
                'boxShadow': `${tm.getTheme().shadows.dropdownShadow.value}`,
                'padding': '8px',
                'display': 'none',
                'position': 'absolute',
                'top': 'calc(100% - 5px)',
                'minWidth': '200px',
                'zIndex': `${tm.getTheme().zIndices.headerDropdown.value}`,
                '&.active': {display: 'block'},
                'ul': {
                    listStyle: 'none',
                    margin: 0,
                    padding: 0,
                },
                '.ninchat-embed-dropdown-item': {marginTop: '5px'},
                '.ninchat-embed-dropdown-item-button': {
                    'color': `${tm.getTheme().colors.buttonText.value}`,
                    'display': 'flex',
                    'alignItems': 'center',
                    'gap': '10px',
                    'background': 'none',
                    'border': 'none',
                    'borderRadius': '6px',
                    '&:hover': {backgroundColor: `${tm.getTheme().colors.dropdownItemBackgroundHover.value}`},
                    'width': '100%',
                    'textAlign': 'left',
                    'padding': '6px 15px',
                    'fontSize': '15px',
                    'fontWeight': 600,
                    'cursor': 'pointer',
                    '&.mute': {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    },
                },
                '.ninchat-embed-dropdown-item-button-icon': {
                    'width': '25px',
                    'height': '25px',
                    'display': 'flex',
                    'alignItems': 'center',
                    'justifyContent': 'center',
                    'img': {
                        maxWidth: '100%',
                        maxHeight: '100%',
                    },
                    '&.chatList': {
                        svg: {
                            width: '19px',
                            height: '18px',
                        },
                    },
                    '&.close': {
                        svg: {
                            width: '15px',
                            height: '15px',
                        },

                    },
                },
            },
            '.ninchat-embed-dropdown-item-button-switch-wrapper': {
                height: '25px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            },
            '.ninchat-embed-dropdown-item-button-switch': {
                'position': 'relative',
                '&.on': {
                    svg: {
                        left: '5px',
                        right: 'initial',
                    },
                },
                '.ninchat-embed-dropdown-item-button-switch-svg': {
                    'display': 'none',
                    '&.show': {display: 'block'},
                },
                'svg': {
                    position: 'absolute',
                    top: '50%',
                    right: '5px',
                    transform: 'translate(0, -50%)',
                    width: '16px',
                    height: '16px',
                    pointerEvents: 'none',
                },
                'input': {
                    '& ~ .ninchat-embed-dropdown-item-button-switch-svg.show svg': {
                        color: `${tm.getTheme().colors.switchIcon.value}`,
                        width: '14px',
                        height: '14px',
                        right: '2px',
                    },
                    '&::before': {
                        backgroundColor: `${tm.getTheme().colors.switchThumbBackground.value}`,
                        borderColor: `${tm.getTheme().colors.switchThumbBorder.value}`,
                        borderRadius: `${tm.getTheme().radii.switchThumb.value}`,
                        borderStyle: `${tm.getTheme().borderStyles.switchThumb.value}`,
                        borderWidth: `${tm.getTheme().borderWidths.switchThumb.value}`,
                        boxSizing: 'border-box',
                        content: '',
                        position: 'absolute',
                        transition: 'all 0.3s',
                        zIndex: 1,
                        width: '14px',
                        height: '14px',
                        top: '1px',
                        left: '1px',
                    },
                    '&:checked': {
                        '& ~ .ninchat-embed-dropdown-item-button-switch-svg.show svg': {
                            color: `${tm.getTheme().colors.switchIconChecked.value}`,
                            left: '3px',
                        },
                        '&::before': {
                            backgroundColor: `${tm.getTheme().colors.switchThumbBackgroundChecked.value}`,
                            left: 'unset',
                            transform: 'translateX(18px)',
                        },
                        'backgroundColor': `${tm.getTheme().colors.switchBackgroundChecked.value}`,
                        'borderColor': `${tm.getTheme().colors.switchBorderChecked.value}`,
                    },
                    '&:disabled': {
                        '& ~ .ninchat-embed-dropdown-item-button-switch-svg.show svg': {color: `${tm.getTheme().colors.switchIconDisabled.value}`},
                        '&::before': {
                            backgroundColor: `${tm.getTheme().colors.switchThumbBackgroundDisabled.value}`,
                            borderColor: `${tm.getTheme().colors.switchThumbBorderDisabled.value}`,
                        },
                        '&:checked': {
                            '& ~ .ninchat-embed-dropdown-item-button-switch-svg.show svg': {color: `${tm.getTheme().colors.switchIconCheckedDisabled.value}`},
                            '&::before': {
                                backgroundColor: `${tm.getTheme().colors.switchThumbBackgroundCheckedDisabled.value}`,
                                borderColor: `${tm.getTheme().colors.switchThumbBorderCheckedDisabled.value}`,
                            },
                            'backgroundColor': `${tm.getTheme().colors.switchBackgroundCheckedDisabled.value}`,
                            'borderColor': `${tm.getTheme().colors.switchBorderCheckedDisabled.value}`,
                        },
                        'backgroundColor': `${tm.getTheme().colors.switchBackgroundDisabled.value}`,
                        'borderColor': `${tm.getTheme().colors.switchBorderDisabled.value}`,
                    },
                    '&:focus-visible:not(:disabled)': {
                        '& ~ .ninchat-embed-dropdown-item-button-switch-svg.show svg': {color: `${tm.getTheme().colors.switchIconFocus.value}`},
                        '&::before': {
                            backgroundColor: `${tm.getTheme().colors.switchThumbBackgroundFocus.value}`,
                            borderColor: `${tm.getTheme().colors.switchThumbBorderFocus.value}`,
                        },
                        '&:checked': {
                            '& ~ .ninchat-embed-dropdown-item-button-switch-svg.show svg': {color: `${tm.getTheme().colors.switchIconCheckedFocus.value}`},
                            '&::before': {
                                backgroundColor: `${tm.getTheme().colors.switchThumbBackgroundCheckedFocus.value}`,
                                borderColor: `${tm.getTheme().colors.switchThumbBorderCheckedFocus.value}`,
                            },
                            'backgroundColor': `${tm.getTheme().colors.switchBackgroundCheckedFocus.value}`,
                            'borderColor': `${tm.getTheme().colors.switchBorderCheckedFocus.value}`,
                        },
                        'backgroundColor': `${tm.getTheme().colors.switchBackgroundFocus.value}`,
                        'borderColor': `${tm.getTheme().colors.switchBorderFocus.value}`,
                        'outlineColor': `${tm.getTheme().colors.switchOutlineFocus.value}`,
                        'outlineStyle': 'solid',
                        'outlineWidth': '2px',
                    },
                    '&:hover:not(:disabled)': {
                        'svg': {
                            fill: 'red',
                            border: '2px solid red',
                        },
                        '&::before': {
                            backgroundColor: `${tm.getTheme().colors.switchThumbBackgroundHover.value}`,
                            borderColor: `${tm.getTheme().colors.switchThumbBorderHover.value}`,
                        },
                        '&:checked': {
                            '& ~ .ninchat-embed-dropdown-item-button-switch-svg.show svg': {color: `${tm.getTheme().colors.switchIconCheckedHover.value}`},
                            '&::before': {
                                backgroundColor: `${tm.getTheme().colors.switchThumbBackgroundCheckedHover.value}`,
                                borderColor: `${tm.getTheme().colors.switchThumbBorderCheckedHover.value}`,
                            },
                            'backgroundColor': `${tm.getTheme().colors.switchBackgroundCheckedHover.value}`,
                            'borderColor': `${tm.getTheme().colors.switchBorderCheckedHover.value}`,
                        },
                        'backgroundColor': `${tm.getTheme().colors.switchBackgroundHover.value}`,
                        'borderColor': `${tm.getTheme().colors.switchBorderHover.value}`,
                    },
                    'appearance': 'none',
                    'backgroundColor': `${tm.getTheme().colors.switchBackground.value}`,
                    'borderColor': `${tm.getTheme().colors.switchBorder.value}`,
                    'borderStyle': `${tm.getTheme().borderStyles.switch.value}`,
                    'borderWidth': `${tm.getTheme().borderWidths.switch.value}`,
                    'display': 'block',
                    'flex': 'none',
                    'margin': 0,
                    'position': 'relative',
                    'transition': 'background-color 0.3s, border-color 0.3s',
                    'userSelect': 'none',
                    'cursor': 'pointer',
                    'width': '34px',
                    'height': '18px',
                    'borderRadius': '4px',
                },
            },
        }
    }

    const mediaQueriesOverrides = breakpoints.reduce((acc: any, breakpoint: ResponsiveBreakpoints[0]) => {
        const {
            mediaQuery, tm: tmNew, config: newConfig,
        } = breakpoint

        acc[`@media ${mediaQuery}`] = renderStyles(newConfig, tmNew)
        return acc
    }, {})

    return css({
        ...renderStyles(defaultConfig, tmDefault),
        ...mediaQueriesOverrides,
    })()
}

export const floatingContainerContent = (defaultConfig: NinchatEnvironmentConfig, tmDefault: ThemeManager, breakpoints: ResponsiveBreakpoints) => {
    const renderStyles = (config: NinchatEnvironmentConfig, _tm: ThemeManager) => {
        const {floatingOptions} = config

        return {
            // '.after-iframe-button, .before-iframe-button': {
            //     opacity: 0,
            //     height: 0,
            //     position: 'absolute',
            //     pointerEvents: 'none',
            // },
            height: '100%',
            overflow: 'hidden',
            transition: `height ${TRANSITION_DURATION}s`,
            ...floatingOptions?.ball
                ? {transition: `height ${BALL_TRANSITION_DURATION}s`}
                : {},
        }
    }

    const mediaQueriesOverrides = breakpoints.reduce((acc: any, breakpoint: ResponsiveBreakpoints[0]) => {
        const {
            mediaQuery, tm: tmNew, config: newConfig,
        } = breakpoint

        acc[`@media ${mediaQuery}`] = renderStyles(newConfig, tmNew)
        return acc
    }, {})

    return css({
        ...renderStyles(defaultConfig, tmDefault),
        ...mediaQueriesOverrides,
    })()
}

export const floatingContainerBall = (defaultConfig: NinchatEnvironmentConfig, tmDefault: ThemeManager, breakpoints: ResponsiveBreakpoints) => {
    const renderStyles = (config: NinchatEnvironmentConfig, tm: ThemeManager) => {
        const {floatingOptions} = config
        const isDockRight = floatingOptions?.dock?.right && !floatingOptions?.dock?.bottom
        const isDockCenter = floatingOptions?.dock?.center
        const isDockLeft = floatingOptions?.dock?.left && !floatingOptions?.dock?.bottom

        const hasTextOrImage = floatingOptions?.ballOptions?.text || floatingOptions?.ballOptions?.image

        const ballHeight = floatingOptions?.ballOptions?.height || BALL_HEIGHT_DEFAULT
        const ballWidth = floatingOptions?.ballOptions?.width || BALL_WIDTH_DEFAULT

        const {rotate} = animations()

        return {
            'backgroundColor': `${tm.getTheme().colors.floatingEmbedBall.value}`,
            'bottom': floatingOptions?.dock?.bottom ? floatingOptions?.ballOptions?.offset?.y || 0 : 'auto',
            'borderRadius': `${tm.getTheme().radii.floatingEmbedBall.value}`,
            'boxShadow': `${tm.getTheme().shadows.floatingEmbedBall.value}`,
            'display': 'flex',
            'justifyContent': 'center',
            'alignItems': 'center',
            'position': 'absolute',
            'pointerEvents': 'all',
            'left': floatingOptions?.dock?.left ? floatingOptions?.ballOptions?.offset?.x || 0 : 'auto',
            'right': floatingOptions?.dock?.right ? floatingOptions?.ballOptions?.offset?.x || 0 : 'auto',
            'zIndex': `${tm.getTheme().zIndices.floatingEmbedBall.value}`,
            ...isDockCenter
                ? {
                    left: '50%',
                    right: 'auto',
                    transform: 'translateX(-50%)',
                }
                : {},
            ...isDockRight
                ? {
                    transform: 'translateY(-50%)',
                    top: `calc(50% + ${floatingOptions?.ballOptions?.offset?.y || 0}px)`,
                }
                : {},
            ...isDockLeft
                ? {
                    transform: 'translateY(-50%)',
                    top: `calc(50% + ${floatingOptions?.ballOptions?.offset?.y || 0}px)`,
                }
                : {},
            '&.transitions-enabled': {transition: `height ${TRANSITION_DURATION}s, width ${TRANSITION_DURATION}s, bottom ${TRANSITION_DURATION}s`},
            '&.hide': {bottom: `-${(floatingOptions?.ballOptions?.height || 0) < BALL_HEIGHT_DEFAULT ? BALL_HEIGHT_DEFAULT : floatingOptions?.ballOptions?.height}px`},
            '&.hide-transition-end': {visibility: 'hidden'},
            '&:not(.hide)': {'.ninchat-embed-promobubble-wrapper': {visibility: 'visible'}},
            '&:hover': {
                'backgroundColor': `${tm.getTheme().colors.floatingEmbedBallHover.value}`,
                '.ninchat-embed-ball-button': {color: `${tm.getTheme().colors.floatingEmbedBallTextHover.value}`},
                '.ninchat-embed-ball-close-button': {display: 'block'},
            },
            '.ninchat-embed-ball-button-wrapper': {position: 'relative'},
            '.ninchat-embed-ball-button': {
                'background': 'none',
                'border': 'none',
                'color': `${tm.getTheme().colors.floatingEmbedBallText.value}`,
                'cursor': 'pointer',
                'padding': `${tm.getTheme().space.floatingEmbedBall.value}`,
                'borderRadius': `${tm.getTheme().radii.floatingEmbedBall.value}`,
                'height': floatingOptions?.ballOptions?.height ? `${floatingOptions?.ballOptions?.height}px` : 'auto',
                'width': floatingOptions?.ballOptions?.width ? `${floatingOptions?.ballOptions?.width}px` : 'auto',
                ...hasTextOrImage
                    ? {}
                    : {
                        height: `${ballHeight}px`,
                        width: `${ballWidth}px`,
                    },

                '&:active': {backgroundColor: `${tm.getTheme().colors.floatingEmbedBallActive.value}`},
            },
            '.ninchat-embed-ball-close-button': {
                'backgroundColor': `${tm.getTheme().colors.floatingEmbedClose.value}`,
                'borderRadius': '6px',
                'border': 'none',
                'color': `${tm.getTheme().colors.floatingEmbedCloseIcon.value}`,
                'cursor': 'pointer',
                'display': 'none',
                'padding': '5px',
                'position': 'absolute',
                'right': '-16px',
                'top': '-16px',
                'width': '24px',
                'height': '24px',
                '> svg': {width: '12px'},
            },
            '.ninchat-embed-ball-text': {
                fontFamily: `${tm.getTheme().fonts.floatingEmbedBall.value}`,
                fontSize: `${tm.getTheme().fontSizes.floatingEmbedBall.value}`,
                fontWeight: `${tm.getTheme().fontWeights.floatingEmbedBall.value}`,
            },
            '.ninchat-embed-ball-image-wrapper': {'&:empty': {display: 'none'}},
            '.ninchat-embed-ball-image-wrapper:not(:empty) + .ninchat-embed-ball-text': {marginLeft: '10px'},
            '.ninchat-embed-ball-image-default': {
                svg: {
                    width: '100%',
                    height: '100%',
                },
            },
            '.ninchat-embed-ball-image': {
                display: 'block',
                height: floatingOptions?.ballOptions?.image?.height ? `${floatingOptions?.ballOptions?.image?.height}px` : 'auto',
                width: floatingOptions?.ballOptions?.image?.width ? `${floatingOptions?.ballOptions?.image?.width}px` : 'auto',
            },
            '.ninchat-embed-ball-image-svg-wrapper': {
                'height': floatingOptions?.ballOptions?.image?.height ? `${floatingOptions?.ballOptions?.image?.height}px` : 'auto',
                'width': floatingOptions?.ballOptions?.image?.width ? `${floatingOptions?.ballOptions?.image?.width}px` : 'auto',
                '> svg': {
                    width: '100%',
                    height: '100%',
                },
            },
            '.ninchat-embed-ball-button-content': {
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center',
            },
            '.ninchat-embed-state-icon-wrapper': {
                'width': '100%',
                'height': '100%',
                'fontSize': `${tm.getTheme().fontSizes.floatingEmbedBallState.value}`,
                'fontWeight': 'bold',
                '&.spinner': {
                    'width': `${tm.getTheme().sizes.floatingEmbedBallInQueueLoader.value}`,
                    'height': `${tm.getTheme().sizes.floatingEmbedBallInQueueLoader.value}`,
                    'position': 'relative',
                    '> svg': {animation: `${rotate} 2s linear infinite`},
                    '> span': {
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                    },
                },
                '&.newMessage': {
                    width: `${tm.getTheme().sizes.floatingEmbedBallNewMessageIcon.value}`,
                    height: `${tm.getTheme().sizes.floatingEmbedBallNewMessageIcon.value}`,
                },
                '&.video': {
                    width: `${tm.getTheme().sizes.floatingEmbedBallVideoIcon.value}`,
                    height: `${tm.getTheme().sizes.floatingEmbedBallVideoIcon.value}`,
                },
                '> svg': {
                    display: 'block',
                    width: '100%',
                    height: '100%',
                },
            },
        }
    }

    const mediaQueriesOverrides = breakpoints.reduce((acc: any, breakpoint: ResponsiveBreakpoints[0]) => {
        const {
            mediaQuery, tm: tmNew, config: newConfig,
        } = breakpoint

        acc[`@media ${mediaQuery}`] = renderStyles(newConfig, tmNew)
        return acc
    }, {})

    return css({
        ...renderStyles(defaultConfig, tmDefault),
        ...mediaQueriesOverrides,
    })()
}

export const floatingContainerPromoBubble = (defaultConfig: NinchatEnvironmentConfig, tmDefault: ThemeManager, breakpoints: ResponsiveBreakpoints) => {
    const renderStyles = (config: NinchatEnvironmentConfig, tm: ThemeManager) => {
        const {floatingOptions} = config
        const isDockRight = floatingOptions?.dock?.right && !floatingOptions?.dock?.bottom
        const isDockLeft = floatingOptions?.dock?.left && !floatingOptions?.dock?.bottom

        const isBall = floatingOptions?.ball

        const xOffset = floatingOptions?.promoBubble?.offset?.x || 0
        const yOffset = floatingOptions?.promoBubble?.offset?.y || 0

        const showCaret = floatingOptions?.promoBubble?.caret
        const headerHeight = floatingOptions?.headerOptions?.height || EMBED_HEADER_HEIGHT_DEFAULT

        const bubbleLeftRightOffset = 30
        const bubbleBallOffset = 20

        return {
            'color': `${tm.getTheme().colors.floatingEmbedPromoBubbleText.value}`,
            'fontFamily': `${tm.getTheme().fonts.floatingEmbedPromoBubble.value}`,
            'fontSize': `${tm.getTheme().fontSizes.floatingEmbedPromoBubble.value}`,
            'display': 'flex',
            'justifyContent': 'center',
            'visibility': 'hidden',
            'position': 'absolute',
            'width': '100vw',
            'left': '50%',
            'top': '-20px',
            'transform': 'translate(-50%, -100%)',
            'pointerEvents': 'none',
            'opacity': 1,
            'transition': 'opacity 1s',
            ...!isDockLeft && !isDockRight && !isBall
                ? {maxWidth: '100%'}
                : {},
            ...isDockLeft
                ? {
                    top: `calc(-50vw - ${bubbleLeftRightOffset}px - ${xOffset}px)`,
                    left: `calc(50% - ${yOffset}px)`,
                    transform: 'translate(-50%, -50%) rotate(-90deg)',
                    justifyContent: 'flex-start',
                }
                : {},
            ...isDockRight
                ? {
                    top: `calc(-50vw - ${bubbleLeftRightOffset}px - ${xOffset}px)`,
                    left: `calc(50% - ${yOffset}px)`,
                    transform: 'translate(-50%, -50%) rotate(90deg)',
                    justifyContent: 'flex-end',
                }
                : {},
            ...isBall
                ? {
                    right: xOffset,
                    top: `calc(-${bubbleBallOffset}px - ${yOffset}px)`,
                    left: 'initial',
                    transform: 'translate(0, -100%)',
                    justifyContent: 'flex-end',
                    ...floatingOptions?.dock?.left
                        ? {
                            right: 'initial',
                            left: xOffset,
                            transform: 'translate(0, -100%)',
                            justifyContent: 'flex-start',
                        }
                        : {},
                }
                : {},
            '&&&.hide': {
                visibility: 'hidden',
                opacity: 0,
            },
            '&&&.hide-pernament': {
                visibility: 'hidden',
                opacity: 0,
            },
            '.ninchat-embed-promobubble-inner': {
                'display': 'flex',
                'flexDirection': 'column',
                'alignItems': 'center',
                'pointerEvents': 'all',
                'padding': '10px',
                'margin': '-10px',
                ...isBall
                    ? {
                        alignItems: 'flex-end',
                        maxWidth: `calc(100vw - 10px - ${xOffset}px - ${floatingOptions?.ballOptions?.offset?.x}px)`,
                        ...floatingOptions?.dock?.left
                            ? {alignItems: 'flex-start'}
                            : {},
                    }
                    : {},
                ...isDockLeft
                    ? {
                        alignItems: 'flex-start',
                        maxWidth: `calc(100vw - ${headerHeight}px  - ${bubbleLeftRightOffset}px - 10px - ${xOffset}px)`,
                    }
                    : {},
                ...isDockRight
                    ? {maxWidth: `calc(100vw - ${headerHeight}px - ${bubbleLeftRightOffset}px - 10px - ${xOffset}px)`}
                    : {},
                '&:hover': {'.ninchat-embed-promobubble-close-button': {display: 'flex'}},
            },
            '.ninchat-embed-promobubble': {
                'backgroundColor': `${tm.getTheme().colors.floatingEmbedPromoBubble.value}`,
                'borderRadius': `${tm.getTheme().radii.floatingEmbedPromoBubble.value}`,
                'boxShadow': `${tm.getTheme().shadows.floatingEmbedPromoBubble.value}`,
                'fontSize': '16px',
                'cursor': 'pointer',
                'border': 'none',
                'padding': '20px',
                'width': 'fit-content',
                'position': 'relative',
                'marginBottom': '10px',
                ...showCaret
                    ? {
                        '&:last-child': {
                            ...isBall
                                ? {
                                    borderBottomRightRadius: 0,
                                    ...floatingOptions?.dock?.left
                                        ? {
                                            borderRadius: `${tm.getTheme().radii.floatingEmbedPromoBubble.value}`,
                                            borderBottomLeftRadius: 0,
                                        }
                                        : {},
                                }
                                : {},
                            '&:after': {
                                content: '',
                                position: 'absolute',
                                left: '50%',
                                bottom: '-20px',
                                transform: 'translateX(-50%)',
                                borderWidth: '10px',
                                borderColor: 'transparent',
                                borderStyle: 'solid',
                                borderTopColor: `${tm.getTheme().colors.floatingEmbedPromoBubble.value}`,
                                ...isDockLeft
                                    ? {
                                        left: '-20px',
                                        top: '50%',
                                        bottom: 'initial',
                                        transform: 'translateY(-50%)',
                                        borderRightColor: `${tm.getTheme().colors.floatingEmbedPromoBubble.value}`,
                                        borderTopColor: 'transparent',
                                    }
                                    : {},
                                ...isDockRight
                                    ? {
                                        left: 'initial',
                                        right: '-20px',
                                        top: '50%',
                                        bottom: 'initial',
                                        transform: 'translateY(-50%)',
                                        borderLeftColor: `${tm.getTheme().colors.floatingEmbedPromoBubble.value}`,
                                        borderTopColor: 'transparent',
                                    }
                                    : {},
                                ...isBall
                                    ? {display: 'none'}
                                    : {},
                            },
                        },
                    }
                    : {},
                '> p': {margin: 0},

            },
            '.ninchat-embed-promobubble-close-button': {
                'cursor': 'pointer',
                'display': 'none',
                'alignItems': 'center',
                'justifyContent': 'center',
                'border': 'none',
                'backgroundColor': `${tm.getTheme().colors.floatingEmbedClose.value}`,
                'borderRadius': '6px',
                'color': `${tm.getTheme().colors.floatingEmbedCloseIcon.value}`,
                'position': 'absolute',
                'right': '-20px',
                'top': '-20px',
                'width': '24px',
                'height': '24px',
                '> svg': {width: '12px'},
            },
        }
    }

    const mediaQueriesOverrides = breakpoints.reduce((acc: any, breakpoint: ResponsiveBreakpoints[0]) => {
        const {
            mediaQuery, tm: tmNew, config: newConfig,
        } = breakpoint

        acc[`@media ${mediaQuery}`] = renderStyles(newConfig, tmNew)
        return acc
    }, {})

    return css({
        ...renderStyles(defaultConfig, tmDefault),
        ...mediaQueriesOverrides,
    })()
}

